import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReopen = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_16423_1153)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M14.6909 2.84416L13.7509 3.57916C12.4693 1.94083 10.4759 0.88916 8.2376 0.88916C4.3726 0.88916 1.24426 4.01416 1.23926 7.88083C1.23426 11.7508 4.36926 14.8892 8.2376 14.8892C11.2593 14.8892 13.8343 12.9725 14.8143 10.2875C14.8393 10.2175 14.8026 10.1392 14.7326 10.1158L13.7876 9.79083C13.7546 9.77953 13.7186 9.78158 13.6871 9.79653C13.6557 9.81148 13.6313 9.83815 13.6193 9.87083C13.5893 9.95416 13.5559 10.0375 13.5209 10.1192C13.2326 10.8025 12.8193 11.4158 12.2926 11.9425C11.7702 12.4659 11.1516 12.8835 10.4709 13.1725C9.76593 13.4708 9.01426 13.6225 8.24093 13.6225C7.46593 13.6225 6.71593 13.4708 6.01093 13.1725C5.32956 12.8848 4.7108 12.467 4.18926 11.9425C3.66543 11.4201 3.24824 10.8009 2.96093 10.1192C2.6626 9.41249 2.51093 8.66249 2.51093 7.88749C2.51093 7.11249 2.6626 6.36249 2.96093 5.65583C3.24926 4.97249 3.6626 4.35916 4.18926 3.83249C4.71593 3.30583 5.32926 2.89249 6.01093 2.60249C6.71593 2.30416 7.4676 2.15249 8.24093 2.15249C9.01593 2.15249 9.76593 2.30416 10.4709 2.60249C11.1523 2.89023 11.7711 3.30802 12.2926 3.83249C12.4576 3.99749 12.6126 4.17249 12.7559 4.35583L11.7526 5.13916C11.7327 5.15452 11.7176 5.17517 11.709 5.19873C11.7004 5.2223 11.6985 5.24782 11.7038 5.27237C11.709 5.29692 11.721 5.31949 11.7385 5.3375C11.756 5.35551 11.7782 5.36822 11.8026 5.37416L14.7293 6.09083C14.8126 6.11083 14.8943 6.04749 14.8943 5.96249L14.9076 2.94749C14.9059 2.83749 14.7776 2.77583 14.6909 2.84416Z",
				fill: "#69C0FF"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M7.46191 10.8223C7.46191 11.0345 7.5462 11.238 7.69623 11.388C7.84626 11.538 8.04974 11.6223 8.26191 11.6223C8.47409 11.6223 8.67757 11.538 8.8276 11.388C8.97763 11.238 9.06191 11.0345 9.06191 10.8223C9.06191 10.6101 8.97763 10.4066 8.8276 10.2566C8.67757 10.1066 8.47409 10.0223 8.26191 10.0223C8.04974 10.0223 7.84626 10.1066 7.69623 10.2566C7.5462 10.4066 7.46191 10.6101 7.46191 10.8223ZM8.66191 8.95564C8.73525 8.95564 8.79525 8.89564 8.79525 8.82231V4.28897C8.79525 4.21564 8.73525 4.15564 8.66191 4.15564H7.86191C7.78858 4.15564 7.72858 4.21564 7.72858 4.28897V8.82231C7.72858 8.89564 7.78858 8.95564 7.86191 8.95564H8.66191Z",
				fill: "#69C0FF"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_16423_1153",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 14,
				fill: "white",
				transform: "translate(0.888916 0.888916)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgReopen);
export { ForwardRef as ReactComponent };
